import React from 'react';
import { HeroSettings } from '../../types';

interface HeroSettingsTabProps {
  settings: HeroSettings;
  onChange: (settings: HeroSettings) => void;
  onSave: () => void;
  isSaving: boolean;
}

const HeroSettingsTab: React.FC<HeroSettingsTabProps> = ({ settings, onChange, onSave, isSaving }) => {
  const update = (field: keyof HeroSettings, value: any) =>
    onChange({ ...settings, [field]: value });

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
        <h3 className="font-semibold text-blue-900 mb-2">Hero Section Settings</h3>
        <p className="text-sm text-blue-800">Configure the main landing page hero banner</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Company Name</label>
          <input type="text" value={settings.companyName} onChange={(e) => update('companyName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Company Subtitle</label>
          <input type="text" value={settings.companySubtitle} onChange={(e) => update('companySubtitle', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Mission Statement Line 1</label>
        <input type="text" value={settings.missionLine1} onChange={(e) => update('missionLine1', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Mission Statement Line 2</label>
        <input type="text" value={settings.missionLine2} onChange={(e) => update('missionLine2', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Mission Statement Line 3</label>
        <input type="text" value={settings.missionLine3} onChange={(e) => update('missionLine3', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Primary Button Text</label>
          <input type="text" value={settings.primaryButtonText} onChange={(e) => update('primaryButtonText', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Primary Button Link</label>
          <input type="text" value={settings.primaryButtonLink} onChange={(e) => update('primaryButtonLink', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Secondary Button Text</label>
          <input type="text" value={settings.secondaryButtonText} onChange={(e) => update('secondaryButtonText', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Secondary Button Link</label>
          <input type="text" value={settings.secondaryButtonLink} onChange={(e) => update('secondaryButtonLink', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>

      <div className="flex items-center">
        <input type="checkbox" checked={settings.isActive} onChange={(e) => update('isActive', e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
        <label className="ml-2 block text-sm text-gray-900">Active</label>
      </div>

      <div className="flex justify-end space-x-3 pt-4 border-t">
        <button onClick={onSave} disabled={isSaving} className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50">
          {isSaving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
};

export default HeroSettingsTab;
